<script>
	import Viewer from './components/Viewer.svelte'
	import analytics from './utils/analytics.js'
	import { settings } from './stores.js'

	if (URL) {
		const queryParams = (new URL(document.location)).searchParams
		if (queryParams.get('noTrack') != null) {
			$settings.noTrack = true
		}
		if (queryParams.get('screenshot') != null) {
			$settings.showDonation = false
		}
	}

	if (!$settings.noTrack) analytics.init()
</script>

<main>
	<Viewer />
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

</style>
